    import Axios from 'axios'
    import Store from '@/store/index'
    import Router from '@/router'
    import Aplicacion from '@/controlador/aplicacion'

    const url_api = ()=>{ return Store.state.url_api }
    const token = ()=>{ return Store.state.token }
    const user = ()=>{ return Store.state.user }

    const User = {

        async update_lite(json){

            Aplicacion.mini_loading(true)

            await Axios.put(`${url_api()}update_user_lite`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
            .then(response =>{
                
                if(response.data.errores == 300){
                    var nlocal ={
                        'run':true,
                        'tipo':'alerta',
                        'titulo':user().email,
                        'contenido':'Wrong Entry!',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }
                    Store.commit('set_notificacion_local',nlocal)
                    Aplicacion.mini_loading(false)

                }

                if(response.data.errores == 0){
                    Aplicacion.mini_loading(false)
                    Aplicacion.notificar_realizado('User updated')
                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            }).finally()
        
        },
        
        async cambiar_pass(json){

            Aplicacion.loading(true)

            await Axios.put(`${url_api()}update_pass`,json,{'headers':{'content-type':'applicaction/json','Authorization':`Bearer ${token()}`}})

            .then(response => { 

                Aplicacion.loading(false)

                if(response.data.errores >= 1 && response.data.errores <= 300){

                    var nlocal ={
                      'run':true,
                      'tipo':'alerta', 
                      'titulo':user().email,
                      'contenido':'Solicitud rechazada!, verifique las contraseñas antes de continuar',
                      'errores':[],
                      'tiempo':6000,
                      'cerrar':false
                    }

                    Store.commit('set_notificacion_local',nlocal)
   
                }

                if(response.data.errores == 500){

                    var nlocal ={
                        'run':true,
                        'tipo':'advertencia', 
                        'titulo':user().email,
                        'contenido':' Contraseña incorrecta, Acceso no autorizado!',
                        'errores':[],
                        'tiempo':10000,
                        'cerrar':false
                    }
  
                    Store.commit('set_notificacion_local',nlocal)
     
                }

                if(response.data.errores == 0){
                    Store.dispatch('realizado')
                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            }).finally()


        }

    }

    export default User